import { BuildType } from './ApiService';

export interface ZigBotFeedbackItem {
    id: string;
    rating: number | null;
    comment: string | null;
    createdAt: string;
}

export interface ZigBotFeedbackUserGroup {
    userId: string;
    userName: string;
    userEmail: string;
    feedback: ZigBotFeedbackItem[];
}

export interface ZigBotFeedbackAdminModel {
    users: ZigBotFeedbackUserGroup[];
    total: number;
    page: number;
    limit: number;
}

export interface ListZigBotFeedbackArgs {
    page: number;
    limit: number;
}

export const zigbotFeedbackService = (build: BuildType) => ({
    submitZigBotFeedback: build.mutation<{ id: string }, { rating?: number; comment?: string }>({
        query: body => ({
            url: 'zigbot/feedback',
            method: 'POST',
            body,
        }),
        invalidatesTags: ['ZigBotFeedback'],
    }),
    getZigBotFeedback: build.query<ZigBotFeedbackAdminModel, ListZigBotFeedbackArgs>({
        query: ({ page, limit }) => `zigbot/feedback?page=${page}&limit=${limit}`,
        providesTags: ['ZigBotFeedback'],
    }),
});
